import { EmbeddedQuestionTeaser } from 'feature/teaser/embedded-question-teaser';
import { component, componentWithVariants, demoFile, variant } from 'system/demo';

demoFile('feature/teaser/embedded-question-teaser');

const question = {
    key: '1',
    from: 'a',
    text: 'Is Godzilla good?',
    deleted: false,
};

// Embedded Question Teaser
componentWithVariants('EmbeddedQuestionTeaser', EmbeddedQuestionTeaser, {}, [
    variant(null, {
        structureKey: 'question',
        instanceKey: '1',
        state: {
            embeddedInstanceData: {
                question: {
                    '1': {
                        globals: { name: 'Is Godzilla good?' },
                    },
                },
            },
            collections: {
                question: [question],
            },
        },
    }),
    variant('Multiple Questions', {
        state: {
            collections: {
                question: [{ ...question, key: 2, text: 'Should we welcome Godzilla to Tokyo?' }, question],
            },
        },
    }),
    variant('No Questions', {
        state: {
            collections: {
                question: [],
            },
        },
    }),
]);
